import type { ResultTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const resultDark: ResultTheme = {
  name: 'Result',
  common: commonDark,
  self
}

export default resultDark
